import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import './App.css';
import { PasswordlessLogin } from './components/PasswordlessLogin';
import { UserProfile } from './components/UserProfile';
import { Callback } from './components/Callback';

function App() {
  const { isLoading, error, isAuthenticated, user, logout } = useAuth0();
  const [app1Url, setApp1Url] = useState(
    'https://auth-poc-react.develop.swan.so'
  );
  const [app2Url, setApp2Url] = useState(
    'https://auth-poc-react-app2.develop.swan.so'
  );

  const handleNavigateToApp1 = () => {
    if (app1Url.trim()) {
      window.location.href = app1Url;
    }
  };

  const handleNavigateToApp2 = () => {
    if (app2Url.trim()) {
      window.location.href = app2Url;
    }
  };

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Oops... {error.message}</div>;

  return (
    <div className="App">
      <Routes>
        <Route path="/callback" element={<Callback />} />
        <Route
          path="/"
          element={
            <header className="App-header">
              <h1>Auth0 Passwordless Demo</h1>

              {isAuthenticated ? (
                <div>
                  <UserProfile user={user} />

                  {/* Navigation Section */}
                  <div
                    style={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '10px',
                      padding: '20px',
                      margin: '20px 0',
                      maxWidth: '400px',
                    }}
                  >
                    {/* App 1 */}
                    <div style={{ marginBottom: '20px' }}>
                      <label
                        style={{
                          display: 'block',
                          marginBottom: '5px',
                          fontSize: '14px',
                        }}
                      >
                        App 1:
                      </label>
                      <input
                        type="url"
                        value={app1Url}
                        onChange={(e) => setApp1Url(e.target.value)}
                        placeholder="Enter App 1 URL"
                        style={{
                          width: '100%',
                          padding: '10px',
                          marginBottom: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                        }}
                      />
                      <button
                        onClick={handleNavigateToApp1}
                        style={{
                          width: '100%',
                          padding: '10px 20px',
                          backgroundColor: '#007bff',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontSize: '16px',
                        }}
                      >
                        Go to App 1
                      </button>
                    </div>

                    {/* App 2 */}
                    <div>
                      <label
                        style={{
                          display: 'block',
                          marginBottom: '5px',
                          fontSize: '14px',
                        }}
                      >
                        App 2:
                      </label>
                      <input
                        type="url"
                        value={app2Url}
                        onChange={(e) => setApp2Url(e.target.value)}
                        placeholder="Enter App 2 URL"
                        style={{
                          width: '100%',
                          padding: '10px',
                          marginBottom: '10px',
                          border: '1px solid #ccc',
                          borderRadius: '5px',
                          fontSize: '14px',
                          boxSizing: 'border-box',
                        }}
                      />
                      <button
                        onClick={handleNavigateToApp2}
                        style={{
                          width: '100%',
                          padding: '10px 20px',
                          backgroundColor: '#28a745',
                          color: 'white',
                          border: 'none',
                          borderRadius: '5px',
                          cursor: 'pointer',
                          fontSize: '16px',
                        }}
                      >
                        Go to App 2
                      </button>
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      logout({
                        logoutParams: { returnTo: window.location.origin },
                      })
                    }
                    style={{ marginTop: '20px', padding: '10px 20px' }}
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <PasswordlessLogin />
              )}
            </header>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
